module.exports = __webpack_public_path__ + "static/media/56.56c2d3dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/56.jpg
// module id = 424
// module chunks = 0